import React from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

function Useradd({ title }) {
  return 2;
}

export default Useradd;
